import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import Portfolio from "../components/Portfolio";
import Contact from "../components/Contact";
import Team from "../components/Team";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div id="top" className="relative bg-[#05050A] text-white">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Portfolio />
      <Contact />
      <Team />
      <Footer />
    </div>
  );
}
